import React, { useState } from 'react';
import { connect } from 'react-redux';

import { checkLastSync } from 'src/reducers/desk/syncWithAttendance';

const RecheckSyncSettingForm = ({ client, dispatch }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleAPISync = async () => {
    await checkLastSync(client)(dispatch, setIsLoading);
  };

  return (
    <div className="d-flex">
      <button className="btn btn-outline-dark" disabled={isLoading} onClick={handleAPISync}>
        Check custom API sync
      </button>
    </div>
  );
};

export default connect()(RecheckSyncSettingForm);
